import { Link } from 'react-router-dom';
import { SimpleJsonMasterPage } from './SimpleJsonMasterPage';
import { useVerificationTemplatePresets } from './useMasters';
import type { VerificationTemplatePreset } from '@citizen-walk/shared-types';

/**
 * M9 verificationTemplatePresets 管理画面 (docs/04 §3-1 M9、Phase 3.5 admin 第 4 弾)。
 *
 * Sprint BG-DataSettings 13 (GAP A-S24/S25):
 *   - JSON モード (SimpleJsonMasterPage) は後方互換のため維持。
 *   - 各 row に「🎨 visual editor で開く」 link を追加し、別 page
 *     (`/masters/verification-template/:presetId`) で visual 編集できるようにする。
 *
 * `template` は VerificationTemplatePreset 型では `unknown` のまま (forward compatible)。
 * 実体は visual editor では PresetTemplateBody shape (perPostQuestions /
 * perClassificationQuestions / targetMode / status / allowFreeComment / defaults...) で
 * 書き込まれ、useTemplateCopyLink (copy/link 機構) が同 shape を読む。
 */
export function VerificationTemplatePresetsPage() {
  const state = useVerificationTemplatePresets();
  return (
    <SimpleJsonMasterPage<VerificationTemplatePreset>
      collectionName="verificationTemplatePresets"
      title="検証テンプレ"
      subtitle="AI 検証のテンプレ (内部 ID: verificationTemplatePresets、docs/04 §3-1 M9)。visual editor / JSON 併用 (GAP A-S24/S25)。"
      jsonFieldName="template"
      jsonFieldLabel="template"
      jsonFieldPlaceholder='{ "displayName": "", "perPostQuestions": [], "perClassificationQuestions": [], "status": "draft" }'
      newIdPlaceholder="例: ecw-default-verification"
      state={state}
      extraRowAction={(item) => (
        <Link
          to={`/masters/verification-template/${item.id}`}
          className="text-xs text-primary-600 hover:text-primary-700 hover:underline min-h-touch px-3 inline-flex items-center"
          aria-label={`${item.displayName} を visual editor で開く`}
        >
          🎨 visual editor
        </Link>
      )}
    />
  );
}
